import { render, staticRenderFns } from "./CatProp.vue?vue&type=template&id=5d8509b5&scoped=true"
import script from "./CatProp.vue?vue&type=script&lang=js"
export * from "./CatProp.vue?vue&type=script&lang=js"
import style0 from "./CatProp.vue?vue&type=style&index=0&id=5d8509b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8509b5",
  null
  
)

export default component.exports